import Vue from 'vue';
import Vuex from 'vuex';
import mainModule from './main';
import invoiceModule from './invoice';
import clientModule from './client';
import settingsModule from './settings';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main: mainModule,
    invoice: invoiceModule,
    client: clientModule,
    settings: settingsModule,
  },
});
